var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8289 14.0875H13.6589C11.8789 14.0875 10.4289 12.6475 10.4289 10.8575V8.6875C10.4289 8.2775 10.0989 7.9375 9.67892 7.9375H6.50892C4.19892 7.9375 2.32892 9.4375 2.32892 12.1175V18.7575C2.32892 21.4375 4.19892 22.9375 6.50892 22.9375H12.3989C14.7089 22.9375 16.5789 21.4375 16.5789 18.7575V14.8375C16.5789 14.4175 16.2389 14.0875 15.8289 14.0875Z",
    fill: "url(#paint0_linear_3780_18311)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1489 2.9375H16.1789H15.0889H12.2589C9.99893 2.9375 8.16893 4.3775 8.08893 6.9475C8.14893 6.9475 8.19893 6.9375 8.25893 6.9375H11.0889H12.1789H14.1489C16.4589 6.9375 18.3289 8.4375 18.3289 11.1175V13.0875V15.7975V17.7675C18.3289 17.8275 18.3189 17.8775 18.3189 17.9275C20.5489 17.8575 22.3289 16.3775 22.3289 13.7675V11.7975V9.0875V7.1175C22.3289 4.4375 20.4589 2.9375 18.1489 2.9375Z",
    fill: "url(#paint1_linear_3780_18311)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3089 8.0892C11.9989 7.7792 11.4689 7.9892 11.4689 8.4192V11.0392C11.4689 12.1392 12.3989 13.0392 13.5389 13.0392C14.2489 13.0492 15.2389 13.0492 16.0889 13.0492C16.5189 13.0492 16.7389 12.5492 16.4389 12.2492C15.3489 11.1592 13.4089 9.2092 12.3089 8.0892Z",
    fill: "url(#paint2_linear_3780_18311)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3780_18311",
    x1: 9.45392,
    y1: 7.9375,
    x2: 9.45392,
    y2: 22.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3780_18311",
    x1: 15.2089,
    y1: 2.9375,
    x2: 15.2089,
    y2: 17.9275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3780_18311",
    x1: 14.0231,
    y1: 7.94141,
    x2: 14.0231,
    y2: 13.0492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshot);
export default __webpack_public_path__ + "static/media/snapshot.a1f57134f9c13c842a4b0bf9058fe4c3.svg";
export { ForwardRef as ReactComponent };